module.exports = __webpack_public_path__ + "static/img/dcc_bg2.9ce5a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/dcc_bg2.png
// module id = YEXS
// module chunks = 1